<template>
    <div v-if="visible" class="act-modal" :style="boxStyle">
        <div class="act-modal-dialog">
            <div v-if="tpl.props.fixedMask" :style="fixedMaskStyle"></div>
            <div :class="dialogPositionClass">
                <a href="javascript:void(0);" v-if="tpl.props.closable" class="close j_close_btn" title="关闭"
                    @click="onClick"></a>
                <children-renderer></children-renderer>
            </div>
        </div>
    </div>
</template>
<script>
import { FlowContainerForRender } from "../sdk/container/render";
const {
    rem: { parseStyle },
} = require("@futuweb/fego-bridge");

export default {
    name: "act-modal",
    mixins: [FlowContainerForRender],
    props: {
        defaultVisible: {
            type: Number,
        },
    },
    data() {
        return {
            visible: !!this.defaultVisible,
        };
    },
    computed: {
        fixedMaskStyle() {
            let { props } = this.tpl;
            let r = {
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                position: "fixed",
                background: props.fixedMaskColor || "transparent",
            };
            return parseStyle(r);
        },
        dialogPositionClass() {
            let { props } = this.tpl;
            return `act-modal-dialog-content-${props.dialogPosition || 'center'}`
        }
    },
    methods: {
        /**
         * 打开弹窗
         * 用于【操作组件】交互
         */
        open() {
            this.visible = true;
        },

        /**
         * 关闭弹窗
         * 用于【操作组件】交互
         */
        close() {
            this.visible = false;
        },
        onClick() {
            this.close();
        },
    },
};
</script>
<style lang="less" scoped>
@import url("../sdk/container/common.less");

.act-modal {
    width: 0 !important;
    height: 0 !important;
    position: relative;
}

.act-modal-dialog {
    display: block;
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 200;
    margin: 0 auto;
}

.act-modal-dialog .act-modal-dialog-content-center {
    display: block;
    position: absolute;
    width: 5.6rem;
    min-height: 5.2rem;
    box-sizing: border-box;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border-radius: 0.1rem;
    background-color: #fff;
    color: #000;
    text-align: center;
}

.act-modal-dialog .act-modal-dialog-content-bottom {
    display: block;
    position: absolute;
    width: 100%;
    min-height: 5.2rem;
    box-sizing: border-box;
    border-radius: 0.1rem;
    background-color: #fff;
    color: #000;
    text-align: center;
    bottom: 0;
    left: 0;


}

.act-modal-dialog-content-bottom .close {
    // background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAaCAMAAAB1owf/AAAAP1BMVEUAAACkpKSkpKSkpKSkpKSkpKSkpKSkpKSkpKSkpKSkpKSkpKSkpKSkpKSkpKSkpKSkpKSkpKSkpKSkpKSkpKRSuHLQAAAAFHRSTlMA8+cZzVEMuyV8bdmxl184pS6LQkRlhzEAAAC7SURBVCjPZZFZFoQgDAQbEEHcNfc/6wyJmEesH5ZCSWggDinDMDm/A47IByOIKGGkP3OnSt0agJnHUcVGlQIE36vo6nqt08wqPeJmccji5MXC813nujzkkH6vv1iR251KJFYqbKnam22P+D0sk4iMD4mY+BELCe424qCG2zux8l5ceDihXO2KJFWYsjYA49BVXlogoqRbbX+CECTJ8D7ZhYYmqRE+ZC9HQ4tGOb1k5DRCTZLvzSXCEraIH1hfEm8cFvxtAAAAAElFTkSuQmCC');
    // background-position: 50%;
    // background-repeat: no-repeat;
    // background-size: 0.3rem;
    // height: 0.9rem;
    // right: 0;
    // position: absolute;
    // top: 0;
    // width: 0.9rem;
    // z-index: 999;

    display: inline-block;
    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAaCAMAAAB1owf/AAAAP1BMVEUAAACkpKSkpKSkpKSkpKSkpKSkpKSkpKSkpKSkpKSkpKSkpKSkpKSkpKSkpKSkpKSkpKSkpKSkpKSkpKSkpKRSuHLQAAAAFHRSTlMA8+cZzVEMuyV8bdmxl184pS6LQkRlhzEAAAC7SURBVCjPZZFZFoQgDAQbEEHcNfc/6wyJmEesH5ZCSWggDinDMDm/A47IByOIKGGkP3OnSt0agJnHUcVGlQIE36vo6nqt08wqPeJmccji5MXC813nujzkkH6vv1iR251KJFYqbKnam22P+D0sk4iMD4mY+BELCe424qCG2zux8l5ceDihXO2KJFWYsjYA49BVXlogoqRbbX+CECTJ8D7ZhYYmqRE+ZC9HQ4tGOb1k5DRCTZLvzSXCEraIH1hfEm8cFvxtAAAAAElFTkSuQmCC);
    background-size: 100%;
    position: absolute;
    top: 10px;
    right: 10px;
    z-index: 999;
    width: .25rem;
    height: .26rem;
}

.act-modal-dialog-content-center .close {
    display: block;
    width: 0.68rem;
    height: 0.68rem;
    background-image: url(//static.futunn.com/activities/images/global/act-dialog-close-ab02c4b0b84e88ff245249fd7a559d55.png);
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-position: 50%;
    position: absolute;
    left: 50%;
    margin-left: -0.34rem;
    bottom: -1rem;
}
</style>



// WEBPACK FOOTER //
// src/render/index.vue